import * as jsxRuntime from "C:\\Users\\Asus\\main-piano\\piano-trainer\\web\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment